import React, { useState } from "react";
import PropTypes from "prop-types";
import { Flex, Segment, Text, Button } from "@fluentui/react-northstar";
import { CloseIcon } from "@fluentui/react-icons-northstar";
import Constants from "../../../constants/text-constants";
import VerticalMenu from "../../atoms/VerticalMenu";
import TellUsAboutYouSettings from "../../organisms/TellUsAboutYouSettings";
import { useMst } from "../../../hooks/useMst";
import LocationsSettings from "../../organisms/LocationsSettings";
import { observer } from "mobx-react";
import SettingsOverlay from "../../atoms/SettingsOverlay";
import AddLocation from "../AddLocation";
import EditLocation from "../EditLocation";
import ChangePasswordSettings from "../ChangePasswordSettings"
import DeleteLocation from "../DeleteLocation";

const Settings = observer((props) => {
  const { closeButtonClicked } = props;
  const { permissionStore, locationStore } = useMst();

  const hasPermissionsLocation = permissionStore.havePermissions("Locations", [
    "GetAll",
  ]);

  const [state, setState] = useState({
    overlayContentType: null,
    overlayContentData: null,
  });

  const [deleteLocation, setDeleteLocation] = useState(null);

  const onAddLocation = () => {
    setOverlayContent("addLocation");
  }

  const onEditLocation = (location) => {
    setOverlayContent("editLocation", location);
  }

  const onChangePassword = () => {
    setOverlayContent("changePassword");
  }

  const renderDeleteLocationContent = () => {
    return (deleteLocation ?
      (<DeleteLocation
        location={deleteLocation}
        onDeleteClose={() => { setDeleteLocation(null) }}
      />
      )
      : null);
  }

  const onDeleteLocation = (location) => {
    setDeleteLocation(location);
  }

  const setOverlayContent = (type, data) => {
    setState((prevState) => ({
      ...prevState,
      overlayContentType: type,
      overlayContentData: data,
    }));
  }

  const getOverlayContent = () => {
    let innerContent = null;
    switch (state.overlayContentType) {
      case "addLocation":
        innerContent = (<AddLocation onClose={() => { setOverlayContent(null); }} />);
        break;
      case "editLocation":
        innerContent = (<EditLocation location={state.overlayContentData} onClose={() => { setOverlayContent(null); }} />);
        break;
      case "changePassword":
        innerContent = (<ChangePasswordSettings onClose={() => { setOverlayContent(null); }} />);
        break;
      default:
        return null;
    }

    return (
      <SettingsOverlay testid="settingsOverlay">
        {innerContent}
      </SettingsOverlay>
    );
  }

  const createMenuItemList = () => {
    const menuItemsList = [
      {
        key: "myAccount",
        content: Constants.MY_ACCOUNT,
        rendercontent: (
          <TellUsAboutYouSettings
            onChangePasswordClick={onChangePassword}
          />),
      },
    ];
    if (hasPermissionsLocation) {
      menuItemsList.push(
        {
          key: "locations",
          content: Constants.LOCATIONS,
          rendercontent:
            <LocationsSettings
              onEditLocationClick={onEditLocation}
              onDeleteLocationClick={onDeleteLocation}
              onAddLocationClick={onAddLocation}
              locations={locationStore.orderedLocations}
            />
        })
    }
    return menuItemsList;
  };

  const menuItems = createMenuItemList();
  const [activeMenuIndex, setActiveMenuIndex] = useState(0);

  const menuItemClickHandler = (idx) => {
    setActiveMenuIndex(idx);
  };

  return (
    <Flex
      className="page full-screen settings-container"
      data-testid="settingsContainer"
    >
      <Segment className="settings-container-inner">
        {getOverlayContent() ??
          (<Flex column>
            <Flex space="between">
              <Text size="larger" weight="semibold" data-testid="settingsTitle">
                {Constants.SETTINGS}
              </Text>
              <Button
                text
                iconOnly
                data-testid={"settingsCloseBtn"}
                className="settings-close-button"
                icon={<CloseIcon />}
                onClick={() => closeButtonClicked(false)}
              />
            </Flex>
            <Flex space="between">
              <Flex className="settings-menu-container">
                <VerticalMenu
                  testId="settingsMenu"
                  items={menuItems}
                  onMenuItemClick={menuItemClickHandler}
                  activeIndex={activeMenuIndex}
                />
              </Flex>
              <Flex className="right-content-container">
                {menuItems[activeMenuIndex].rendercontent}
              </Flex>
            </Flex>
          </Flex>)}
        {renderDeleteLocationContent()}
      </Segment>
    </Flex>
  );
});

Settings.propTypes = {
  closeButtonClicked: PropTypes.func,
};

Settings.defaultProps = {};

export default Settings;
